var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "a-form-model",
        { ref: "form", attrs: { model: _vm.model, rules: _vm.validatorRules } },
        [
          _c(
            "a-form-model-item",
            { attrs: { prop: "" } },
            [_c("j-language", { attrs: { size: "large", width: "100%" } })],
            1
          ),
          _c(
            "a-form-model-item",
            { attrs: { required: "", prop: "username" } },
            [
              _c(
                "a-input",
                {
                  attrs: {
                    size: "large",
                    placeholder: _vm.language["system.loginUser"]
                  },
                  model: {
                    value: _vm.model.username,
                    callback: function($$v) {
                      _vm.$set(_vm.model, "username", $$v)
                    },
                    expression: "model.username"
                  }
                },
                [
                  _c("a-icon", {
                    style: { color: "rgba(0,0,0,.25)" },
                    attrs: { slot: "prefix", type: "user" },
                    slot: "prefix"
                  })
                ],
                1
              )
            ],
            1
          ),
          _c(
            "a-form-model-item",
            { attrs: { required: "", prop: "password" } },
            [
              _c(
                "a-input-password",
                {
                  attrs: {
                    size: "large",
                    type: "password",
                    autocomplete: "false",
                    placeholder: _vm.language["system.loginPassword"]
                  },
                  model: {
                    value: _vm.model.password,
                    callback: function($$v) {
                      _vm.$set(_vm.model, "password", $$v)
                    },
                    expression: "model.password"
                  }
                },
                [
                  _c("a-icon", {
                    style: { color: "rgba(0,0,0,.25)" },
                    attrs: { slot: "prefix", type: "lock" },
                    slot: "prefix"
                  })
                ],
                1
              )
            ],
            1
          ),
          _c(
            "a-row",
            { attrs: { gutter: 0 } },
            [
              _c(
                "a-col",
                { attrs: { span: 16 } },
                [
                  _c(
                    "a-form-model-item",
                    { attrs: { required: "", prop: "inputCode" } },
                    [
                      _c(
                        "a-input",
                        {
                          attrs: {
                            size: "large",
                            type: "text",
                            placeholder: _vm.language["system.verificationCode"]
                          },
                          model: {
                            value: _vm.model.inputCode,
                            callback: function($$v) {
                              _vm.$set(_vm.model, "inputCode", $$v)
                            },
                            expression: "model.inputCode"
                          }
                        },
                        [
                          _c("a-icon", {
                            style: { color: "rgba(0,0,0,.25)" },
                            attrs: { slot: "prefix", type: "smile" },
                            slot: "prefix"
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "a-col",
                { staticStyle: { "text-align": "right" }, attrs: { span: 8 } },
                [
                  _vm.requestCodeSuccess
                    ? _c("img", {
                        staticStyle: { "margin-top": "2px" },
                        attrs: { src: _vm.randCodeImage },
                        on: { click: _vm.handleChangeCheckCode }
                      })
                    : _c("img", {
                        staticStyle: { "margin-top": "2px" },
                        attrs: { src: require("../../assets/checkcode.png") },
                        on: { click: _vm.handleChangeCheckCode }
                      })
                ]
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }